import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { Image } from '../../common/image'
import { TextEllipsisStaticLine } from '../../common/textEllipsis/TextEllipsisStaticLine'
import chatbotIcon from '../chatbot.svg'
import { selectTopicActive } from '../store/slice'

// Icon SVG thu nhỏ (minus) — dùng cho chế độ fullscreen
const MinimizeIcon = ({ onClick }) => (
  <svg
    onClick={onClick}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer', opacity: 0.7, flexShrink: 0 }}
    className="chatbot-header-action-btn"
  >
    <title>Thu nhỏ về popup</title>
    <rect x="2" y="11" width="20" height="2" rx="1" fill="currentColor" />
  </svg>
)

const HeaderChatbot = ({ toggleChatbot, isFullscreen, onToggleFullscreen }) => {
  const topicActive = useSelector(selectTopicActive)
  const newChatText = I18n.t('chatbot.NEW_CHAT')

  return (
    <>
      <div className="chatbot-header">
        <div className="chatbot-title">
          <Image
            src={chatbotIcon}
            className="chatbot-img"
            alt="logo"
            style={{ width: 40, height: 40 }}
          />
          <div className="title-content">
            <Element style={{ fontSize: 14 }} className="main-title">
              FiinGate Assistant
            </Element>
            <TextEllipsisStaticLine
              text={topicActive?.topicTitle || newChatText}
              lineClamp={1}
              isI18n={false}
              appendStyle={{ fontSize: 14, color: '#FFFFFF99' }}
            />
          </div>
        </div>
        {/* Nhóm icon hành động bên phải header */}
        <div className="chatbot-header-actions">
          {/* Icon fullscreen / thu nhỏ tùy theo trạng thái */}
          {isFullscreen ? (
            <MinimizeIcon onClick={onToggleFullscreen} />
          ) : (
            <Icon
              className="icon-extend chatbot-header-action-btn"
              style={{
                color: '#F3F3F3',
                fontSize: 16,
                opacity: 0.7,
                cursor: 'pointer',
                flexShrink: 0,
              }}
              onClick={onToggleFullscreen}
              title="Mở rộng toàn màn hình"
            />
          )}
          {/* Icon đóng chatbot hoàn toàn */}
          <Icon
            style={{
              color: '#F3F3F3',
              fontSize: 16,
              opacity: 0.7,
              cursor: 'pointer',
            }}
            onClick={toggleChatbot}
            className="icon-delete-circle-fill chatbot-header-action-btn"
            title="Đóng chatbot"
          />
        </div>
      </div>
    </>
  )
}

export default HeaderChatbot
